import type { QuoteProductClassesListResponse } from './api';

export const normalizeQuoteProductClassesList = (
  list: QuoteProductClassesListResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
